module.exports = __webpack_public_path__ + "static/media/vacancyRequestAssistant.7331d54f.svg";